export interface RegisterRequest {
  firstName: string;
  lastName?: string;
  email: string;
  phone?: string;
  password: string;
  confirmPassword: string;
}

export const PASSWORD_STRENGTH_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s]).+$/;
export const PHONE_PATTERN = /^(\+1\d{10}|\+91\d{10}|\d{10})$/;
